import api from 'services/technical-visit/technician'

export const handleSave = async (values: any) => {
  let res = await api.create(values)

  return res?.data?.success
}
